// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"kpb5P","srOnly":"kpb5P"};